import { RiStopCircleLine } from '@remixicon/react';

import { Text } from '@spotify-internal/encore-web';

import styles from './UserInterruptMessage.module.css';

export const UserInterruptMessage = () => (
  <div className={styles.root}>
    <RiStopCircleLine size={14} className={styles.icon} />
    <Text variant="bodySmall" semanticColor="textSubdued">
      Response interrupted by the user. Any running child agents were also
      cancelled.
    </Text>
  </div>
);
